<template>
  <v-container id="fcreate" fluid>
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="'Создать техническую карту'" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-form ref="form" v-model="valid">
          <v-container fluid>
            <v-row>
              <!-- Название -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.name"
                  label="Название"
                  outlined
                  required
                  :rules="rules.required"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Вес -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.weight"
                  label="Вес"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Белки -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.proteins"
                  label="Белки"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Жиры -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.fats"
                  label="Жиры"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Углеводы -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.carbohydrates"
                  label="Углеводы"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Калорийность -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.calories"
                  label="Калорийность"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Состав -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.composition"
                  label="Состав"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Состав для повара -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.compositionForCook"
                  label="Состав для повара"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Тип приготовления (Холодный/Жаренный/Запеченый/Варка) -->
              <v-col cols="12">
                <v-radio-group v-model="data.cookingType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Тип готовки: '" />
                  </template>
                  <v-radio value="cold" label="Холодный" />
                  <v-radio value="fried" label="Жаренный" />
                  <v-radio value="baked" label="Запеченый" />
                  <v-radio value="boiled" label="Варка" />
                </v-radio-group>
              </v-col>
              <!-- Класс блюда (ролл/закуска/пицца/салат/суп) -->
              <v-col cols="12">
                <v-radio-group v-model="data.dishType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Класс блюда: '" />
                  </template>
                  <v-radio value="roll" label="Ролл" />
                  <v-radio value="sushi" label="Суши" />
                  <v-radio value="pizza" label="Пицца" />
                  <v-radio value="salad" label="Салат" />
                  <v-radio value="soup" label="Суп" />
                  <v-radio value="drink" label="Напиток" />
                  <v-radio value="souse" label="Соус" />
                </v-radio-group>
              </v-col>
              <!-- Кто готовит (цех) - горячий/холодный/сборщик -->
              <v-col cols="12">
                <v-radio-group v-model="data.manufacturerType" row>
                  <template v-slot:label>
                    <div class="text-body-2" v-text="'Кто готовит: '" />
                  </template>
                  <v-radio value="cold" label="Холодный" />
                  <v-radio value="hot" label="Горячий" />
                  <v-radio value="collector" label="Сборщик" />
                </v-radio-group>
              </v-col>

              <!-- Цветовая маркировка -->
              <v-col cols="12" md="7">
                <v-select
                  v-model="data.colorMark"
                  outlined
                  :items="colorMarksAll"
                  label="Цветовая маркировка"
                  item-text="name"
                  item-value="code"
                >
                  <template slot="prepend-inner">
                    <div
                      style="display:inline-block; height: 24px; width: 24px; margin-right: 20px; vertical-align: middle; border-radius: 4px"
                      :style="{background: selectedColorMarkObject.value.color}"
                    ></div>
                  </template>
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          :id="attrs['aria-labelledby']"
                        >
                          <div
                            style="display:inline-block; height: 24px; width: 24px; margin-right: 20px; vertical-align: middle; border-radius: 4px"
                            :style="{background: item.color}"
                          ></div>
                          {{ item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>

              <!-- Флаги для сборки-->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.addSpoon"
                  label="Добавлять ложку в сборке"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.addFork"
                  label="Добавлять вилку в сборке"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.customAssemblyCase"
                  label="Кастомный кейс сборки"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>

              <!-- Комментарий от шеф-повара -->
              <v-col cols="12" md="7">
                <v-textarea
                  v-model="data.chefComment"
                  label="Комментарий от шеф-повара"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Таймер приготовления в печи -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.cookingTime"
                  label="Таймер приготовления в печи (в минутах)"
                  :rules="rules.number"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Расчетное время приготовления -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.termTime"
                  label="Расчетное время приготовления (в минутах)"
                  :rules="rules.number"
                  outlined
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Флаг необходимости термообработки -->
              <v-col cols="12" md="7">
                <v-checkbox
                  v-model="data.hasTerm"
                  label="Необходимость термообработки"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Максимальное время нахождения приготовленного блюда в ячейке (время остывания) -->
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="data.timeToCool"
                  label="Максимальное время нахождения приготовленного блюда в ячейке (время остывания) (в минутах)"
                  outlined
                  :rules="rules.number"
                  :disabled="loading"
                  :loading="loading"
                />
              </v-col>
              <!-- Submit -->
              <v-col cols="12" md="7">
                <v-row>
                  <v-col cols="6">
                    <v-btn
                      block
                      large
                      :loading="loading"
                      :disabled="loading"
                      @click.prevent="$router.push('/technicalCards')"
                    >
                      Отмена
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn
                      block
                      large
                      class="mb-2"
                      color="success"
                      :loading="loading"
                      :disabled="loading"
                      @click.prevent="submit"
                    >
                      Создать
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import rules from '@/mixins/rules'
  import TCardColorMark from '../../models/enums/TCardColorMark'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          termTime: '',
          weight: '',
          proteins: '',
          fats: '',
          carbohydrates: '',
          calories: '',
          composition: '',
          compositionForCook: '',
          chefComment: '',
          cookingType: '',
          dishType: '',
          manufacturerType: '',
          timeToCool: '',
          cookingTime: '',
          hasTerm: true,
          sortOrder: 1,
          status: true,
          colorMark: TCardColorMark.noneValue(),
          addSpoon: false,
          addFork: false,
          customAssemblyCase: false,
        },
        valid: false,
        loading: false,
        snackbar: false,
        colorMarksAll: TCardColorMark.getAllVariants(),
      }
    },
    computed: {
      selectedColorMarkObject () {
        return new TCardColorMark(this.data.colorMark)
      },
    },
    methods: {
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loading = true
          try {
            const res = await this.$store.dispatch('technicalCards/createTechnicalCards', this.data)
            if (res.status && res.status === 200) {
              this.$router.push('/technicalCards')
            }
          } catch (e) {
            console.log(e)
          }
          this.loading = false
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
